import ordersIcon from "../../assets/orders-icon.png";

export const OrdersIcon = ({ size = 30, className, ...props }) => (
  <img
    src={ordersIcon}
    width={size}
    height={size}
    alt="Orders"
    className={`object-contain ${className || ""}`.trim()}
    {...props}
  />
);
